<template>
    <messenger
    :account="account"
    :model="client"
    v-bind="{data}"
    type="clients" />
</template>

<script>
import Messenger from "@components/Messenger"
export default {
    props: {
        client: {
            type: [String, Number],
            default: null
        },

        account: {
            type: [String, Number],
            default: null
        },


        data: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {}
    },

    computed: {},

    components: {Messenger},

    methods: {},

    mounted() {
    },

    watch: {}
}

</script>